import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, FormHelperText, TextField } from '@mui/material';
import { useCallback, useEffect, useState, } from 'react';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { pad0 } from 'utils';
import { useAppSelector } from 'shared/hooks/redux/hooks';
const focusInput = (input) => {
    input?.focus();
};
export function ServicePasswordPrompt(props) {
    const [value, setValue] = useState('');
    const [wrong, setWrong] = useState(false);
    useEffect(() => {
        if (props.open) {
            setValue('');
            setWrong(false);
        }
    }, [props.open]);
    const onChange = useCallback((e) => {
        setValue(e.currentTarget.value);
        setWrong(false);
    }, [setValue]);
    const onDone = useCallback(() => {
        if (pad0(value, 4) === pad0(props.actualPassword, 4) ||
            (value === '' && 'admin' === props.actualPassword)) {
            props.onEnterServiceMode();
            props.onClose();
        }
        else {
            setWrong(true);
        }
    }, [value]);
    const onKeyDown = useCallback((ev) => {
        if (ev.key == 'Enter') {
            ev.stopPropagation();
            ev.preventDefault();
            onDone();
        }
    }, [onDone]);
    const nextUiGuide = useAppSelector((state) => state.ui_guide_state.store_helpers.next);
    const onDoneClick = useCallback(() => {
        onDone();
        nextUiGuide?.();
    }, [onDone, nextUiGuide]);
    return (_jsxs(MessageBox, { open: props.open, onClose: props.onClose, title: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", footer: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: props.onClose, children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx(Button, { color: "primary", onClick: onDoneClick, children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438" })] }), data_tooltip: "message-dialog", disableEnforceFocus: true, children: [_jsx("form", { autoComplete: "off", children: _jsx(TextField, { focused: true, variant: "outlined", 
                    // type="password"
                    size: "small", fullWidth: true, value: value, onChange: onChange, onKeyDown: onKeyDown, error: wrong }) }), !wrong && (_jsxs(FormHelperText, { children: ["\u041F\u0430\u0440\u043E\u043B\u044C \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E: ", props.defaultPassword] })), wrong && _jsx(FormHelperText, { error: true, children: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C" })] }));
}
